import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { PrimaryButtonComponent } from '../../../../../shared/components/primary-button/primary-button.component';
import { CourseGalleryItemDTO } from '../../models/LearningPlanDTO';
import { MatIcon } from '@angular/material/icon';
import { ButtonType } from '../../../../../shared/components/primary-button/ButtonType';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDialog } from '@angular/material/dialog';
import { LinkComponent } from '../../../../../shared/components/link/link.component';
import { CoursePreviewService } from '../../../course/services/course-preview.service';

@Component({
  selector: 'app-course-gallery-card',
  imports: [PrimaryButtonComponent, MatIcon, TranslocoModule, LinkComponent],
  templateUrl: './course-gallery-card.component.html',
})
export class CourseGalleryCardComponent {
  dialog = inject(MatDialog);
  private readonly coursePreviewService = inject(CoursePreviewService);

  @Input({ required: true }) course: CourseGalleryItemDTO;
  @Output() courseClicked: EventEmitter<void> = new EventEmitter<void>();
  protected readonly buttonType = ButtonType;

  onCoursePreviewClick(courseId: string) {
    return () => void this.coursePreviewService.open(courseId);
  }

  addCourseToLearningPlan(): void {
    this.courseClicked.emit();
  }
}
